import React, { Component } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { NavbarBrand } from 'react-bootstrap';
import NHP from "../images/NHPLogo_new1.webp";
import NRSC from "../images/NRSCLogo_new1.webp";
import Hydrosight from "../images/HydroSight_v1.webp";
//import Hydrosight_small from "../images/HydroSight_v1_s.png";

import bhuvan_logo_small from "../images/bhuvanLogo_new1.webp";
import "../MainHeader.css";
import { Link } from "react-router-dom";
//import info from './info.png'
//import colors from "./colors";
import { connect } from "react-redux";
import { displayAboutModal } from "./redux_components/actions/CommonActions";
//import NHPCASLogin from './NHPCASLogin'
//import HeaderCommon from "./HeaderCommon";
//import CasClient, { constant } from "./casClient";
import cas from "./casClient/CasService";
//import auth from './casClient/AuthService'
//import Axios from "axios";
import { NavItem } from 'mdbreact';
/* This class defines state variables of all geoportals and CAS Login 
* @HeaderMain
* 
*/
 class MainHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      isWideEnough: false,
      dropdownOpenAbout: false,
      dropdownOpenTeams: false,
      dropdownOpenProjects: false,
      isOpen: false,
      run: false,
      auth: false,
      user: null,
     // isOpen: false,
      username: null,
      ticketKey: null,
      modal: false,
      isDropdownOpen:false,
      isDropdownProductsOpen:false,
      isHomeOpen:false,
      isDownloadsOpen:false,
      isTrainingOpen:false,
      isLoginOpen:false,

      scrolled: false,
    };
  
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    console.log("scrolling")
    const isScrolled = window.scrollY > 0;
    if (isScrolled !== this.state.scrolled) {
      this.setState({ scrolled: isScrolled });
    }
  };
handleMouseEnter = () => {
  this.setState({ isDropdownOpen: true,
  isDropdownProductsOpen:false});
};
handleMouseLeave = () => {
  this.setState({ isDropdownOpen: false });
};
handleMouseEnterHome = () => {
  this.setState({ isHomeOpen: true,  
  isDropdownOpen:false,
isDropdownProductsOpen:false});
};

handleMouseLeaveHome = () => {
  this.setState({ isDropdownOpen: false });
};
handleMouseEnterDownloads = () => {
  this.setState({ isDownloadsOpen: true,
  isDropdownOpen:false,
isDropdownProductsOpen:false});
};
onClick = () => {
  this.setState({
    collapse: !this.state.collapse,
  });
};

handleMouseLeaveDownloads = () => {
  this.setState({ isDownloadsOpen: false });
};

handleMouseLeaveTraining = () => {
  this.setState({ isTrainingOpen: false ,
  });
  };
handleMouseEnterTrainig = () => {
  this.setState({ isTrainingOpen: true,
  
    isDropdownOpen:false,

  isDropdownProductsOpen:false});
};

handleMouseLeaveLogin = () => {
  this.setState({ isLoginOpen: false });
};
handleMouseEnterLogin = () => {
  this.setState({ isLoginOpen: true ,
    isDropdownOpen:false,

    isDropdownProductsOpen:false});
  };
 handleDropdownMouseEnter = () => {
    this.setState({ isDropdownProductsOpen: true,
      isDropdownOpen:false
    });
  };

  handleDropdownMouseLeave = () => {
    this.setState({ isDropdownProductsOpen: false });
  };
  handleLogin = async () => {
    try {
      cas.redirect();
      let result = await cas.getLogin()
      console.log(result)
    } catch (err) {
      if (err.error !== "login_required") console.log("error: " + err);
    }
  }
  async componentDidMount() {
    console.log(window.sessionStorage.getItem("loginUser"))
    console.log(window.sessionStorage.getItem("ticketUser"))
    let resultf = cas.getLogin()
    console.log(resultf)
    if (resultf === null) {
      cas.saveTicket();
      await cas.getTicketCAS();

      this.setState({
        username: cas.getLogin(),
        ticketKey: cas.getTicket()
      })

    }
    else {
      this.setState({
        username: window.sessionStorage.getItem("loginUser"),
        ticketKey: window.sessionStorage.getItem("ticketUser")
      })
    }
  }
    /**
     * CAS Logout
     * 
     */
  handleLogout = async () => {
    await cas.logout()
  }

  /**
     * Mobile frientdly Toggle onClick Method
     * 
     */
  onClick = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };
  /**
     * About Toggle
     * 
     */
   
  toggleAbout = () => {
    this.setState({
      dropdownOpenAbout: !this.state.dropdownOpenAbout,
    });
  };
 f = () => {
    this.setState({
      dropdownOpenAbout: !this.state.dropdownOpenAbout,
    });
  };
   /**
     * Teams Toggle
     * 
     */
  toggleTeams = () => {
    this.setState({
      dropdownOpenTeams: !this.state.dropdownOpenTeams,
    });
  };
   /**
     * Projects Toggle
     * 
     */
  toggleProjects = () => {
    this.setState({
      dropdownOpenProjects: !this.state.dropdownOpenProjects,
    });
  };


  
  render() {
    //const { isDropdownOpen } = this.state;
       // const { isDropdownProductsOpen } = this.state;
        const { scrolled } = this.state;




      const brandStyle = {
        marginLeft: 'auto',
        marginRight: '2px',
        
      };
  
      const menuStyle = {
        flexWrap: 'wrap',
      };
  
      return (
        <>
<Navbar expand="lg" className="larger-navbar justify-content-between">
<Navbar.Brand style={{margin:"8px"}}>
       

          <img src={Hydrosight} className="leftlogo1 "    // specify small image for screens 480px and below
 alt="BrandLogo" />
        </Navbar.Brand>
        <NavbarBrand className='ml-auto'>
        
        <a
                    href="https://www.isro.gov.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    // target="_blank"
                  >
          <img src={NRSC} className="rightlogo1 img-fluid"  alt="BrandLogo1" />
          </a> </NavbarBrand>
        <NavbarBrand>
        
        <a
                      href="https://bhuvan-app1.nrsc.gov.in"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
          <img src={bhuvan_logo_small} className="rightlogo2 img-fluid" alt="BrandLogo2" />
          </a> </NavbarBrand>

        <NavbarBrand>
        <a
                    href="http://nhp.mowr.gov.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    // target="_blank"
                  >
          <img src={NHP} className= "rightlogo3 img-fluid" alt="Brand Logo 2" />
       </a> </NavbarBrand>
      </Navbar>

      <Navbar expand="sm" className="smaller-navbar">
  <Navbar.Toggle aria-controls="smaller-navbarToggler" />
  <Navbar.Collapse id="smaller-navbarToggler" className="smaller-collapsed">
          <Nav className="ml-auto" >
            <Nav.Item
          
             title="Home"
             id="basic-nav-dropdown"
             show={this.state.isHomeOpen}
             onMouseEnter={this.handleMouseEnterHome}
             onMouseLeave={this.handleMouseLeaveHome}
           >
              <Nav.Link >
                <Link to="/"   style={{ color: '#217ca3'  }} onMouseEnter={(e) => e.target.parentElement.classList.add('show')}>
                Home <span className="sr-only" style={{color:"red"}}>(current) </span>
                </Link>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
            <NavDropdown
           

              title="About"                   
              id="basic-nav-dropdown"

              show={this.state.isDropdownOpen}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              toggle={this.toggleAbout}
              className='Mainheader-nav'
            >

                <NavDropdown.Item>
                  <Link to ="/about-nhp">NHP</Link>
                  </NavDropdown.Item>
              
                <NavDropdown.Item >
                  <Link to="/pm">Project Management Team</Link>
                  </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link to="/pi">Project Execution Team</Link>
                  </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link to="/rs">Research Scientists & JRFs</Link>
                  </NavDropdown.Item>
                               
              </NavDropdown>
            </Nav.Item>
            <Nav.Item>
            <NavDropdown
              title="Projects"
              id="basic-nav-dropdown"
              show={this.state.isDropdownProductsOpen}
              onMouseEnter={this.handleDropdownMouseEnter}
              onMouseLeave={this.handleDropdownMouseLeave}
              toggle={this.toggleProjects}
              onClick={this.onClick}
              className='Mainheader-nav'


            >
         
                <NavDropdown.Item>
                  <Link to="/webgis-flood/map">Flood Early Warning</Link>
                  </NavDropdown.Item>
                <NavDropdown.Item> 
                <Link to="/webgis-et/map">Evapotranspiration</Link>
                </NavDropdown.Item>
                <NavDropdown.Item> 
                <Link to="/webgis-glacials/map">Glacial Lakes</Link></NavDropdown.Item>
                <NavDropdown.Item>
                <Link to="/webgis-snow/map">Snowmelt Runoff</Link></NavDropdown.Item>
                <NavDropdown.Item>  
                  <Link to="/webgis-vic/map">Hydrological Modelling</Link></NavDropdown.Item>
                <NavDropdown.Item>  
                  <Link to="/webgis-irrigation/map">Irrigation Management</Link></NavDropdown.Item>
                <NavDropdown.Item href="https://bhuvan.nrsc.gov.in/humid/"  target="_blank" rel="noopener noreferrer" >&nbsp;&nbsp;HUMID</NavDropdown.Item>

                <NavDropdown.Item>  
                  <Link to="/webgis-drought/map" >Hydrological Drought</Link></NavDropdown.Item>                              
              </NavDropdown>
            </Nav.Item>
            <NavItem title="Downloads"
             id="basic-nav-dropdown"
             show={this.state.isDownloadsOpen}
             onMouseEnter={this.handleMouseEnterDownloads}
             onMouseLeave={this.handleMouseLeaveDownloads}
           >
            <Nav.Link>
              <Link to ="/nhp-data-download" style={{ color: '#217ca3' }}
 className="first-step">Downloads</Link>
               </Nav.Link></NavItem>
             <NavItem  title="Trainings"
             id="basic-nav-dropdown"
             show={this.state.isTrainingOpen}
             onMouseEnter={this.handleMouseEnterTrainig}
             onMouseLeave={this.handleMouseLeaveTraining}> 
             <Nav.Link>
              <Link to="/trainingnew/courses" style={{ color: '#217ca3' }}
>Trainings </Link></Nav.Link>
          </NavItem>


          {this.state.username !== null && this.state.ticketKey !== null ? <NavItem><a className="nav-link Ripple-parent first-step active">
                Welcome{" "}
                <span style={{ textTransform: "initial" }}>{this.state.username}</span> &nbsp;&nbsp;
                  <span onClick={this.handleLogout}><u>Logout</u></span>
              </a>

              </NavItem> : <NavItem  title="Login" style={{ color: '#217ca3' }}

              id="basic-nav-dropdown"
             show={this.state.isLoginOpen}
             onMouseEnter={this.handleMouseEnterLogin}
             onMouseLeave={this.handleMouseLeaveLogin}
           ><a className="nav-link Ripple-parent first-step active" style={{ color: '#217ca3' }}
           onClick={this.handleLogin}>LogIn </a></NavItem>
              }
           
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
}
}
/**
 * Connect the component to access global state object
 * @param  {Function} mapStateToProps    Function to map state to props
 * @param  {Function} mapDispatchToProps Function to map dispatch to props
 * @return {Object}                    The container component
 */
const mapStateToProps = (state) => {
  return { modal: state.CState.modal };
};
export default connect(mapStateToProps, { displayAboutModal })(MainHeader);
